/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { RetraitVisiteDto } from '../models/retrait-visite-dto';


/**
 * Fonctions de gestion des retraits lors d'une visite
 */
@Injectable({
  providedIn: 'root',
})
export class RetraitsVisiteService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation retraitsVisiteGetListAll
   */
  static readonly RetraitsVisiteGetListAllPath = '/api/retraits-visite/list/{visiteId}';

  /**
   * Renvoie la liste des retraits pour la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retraitsVisiteGetListAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  retraitsVisiteGetListAll$Response(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;
  }): Observable<StrictHttpResponse<Array<RetraitVisiteDto>>> {

    const rb = new RequestBuilder(this.rootUrl, RetraitsVisiteService.RetraitsVisiteGetListAllPath, 'get');
    if (params) {
      rb.path('visiteId', params.visiteId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RetraitVisiteDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des retraits pour la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retraitsVisiteGetListAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retraitsVisiteGetListAll(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;
  }): Observable<Array<RetraitVisiteDto>> {

    return this.retraitsVisiteGetListAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<RetraitVisiteDto>>) => r.body as Array<RetraitVisiteDto>)
    );
  }

  /**
   * Path part for operation retraitsVisiteLoadList
   */
  static readonly RetraitsVisiteLoadListPath = '/api/retraits-visite/load-list/{visiteId}';

  /**
   * Renvoie la liste des retraits pour la visite spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retraitsVisiteLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  retraitsVisiteLoadList$Response(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, RetraitsVisiteService.RetraitsVisiteLoadListPath, 'post');
    if (params) {
      rb.path('visiteId', params.visiteId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des retraits pour la visite spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retraitsVisiteLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  retraitsVisiteLoadList(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.retraitsVisiteLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation retraitsVisiteGet
   */
  static readonly RetraitsVisiteGetPath = '/api/retraits-visite/{retraitId}/{visiteId}';

  /**
   * Renvoie le retrait spécifié pour la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retraitsVisiteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  retraitsVisiteGet$Response(params: {

    /**
     * Identifiant du retrait
     */
    retraitId: number;

    /**
     * Identifiant de la visite
     */
    visiteId: number;
  }): Observable<StrictHttpResponse<RetraitVisiteDto>> {

    const rb = new RequestBuilder(this.rootUrl, RetraitsVisiteService.RetraitsVisiteGetPath, 'get');
    if (params) {
      rb.path('retraitId', params.retraitId, {});
      rb.path('visiteId', params.visiteId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RetraitVisiteDto>;
      })
    );
  }

  /**
   * Renvoie le retrait spécifié pour la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retraitsVisiteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retraitsVisiteGet(params: {

    /**
     * Identifiant du retrait
     */
    retraitId: number;

    /**
     * Identifiant de la visite
     */
    visiteId: number;
  }): Observable<RetraitVisiteDto> {

    return this.retraitsVisiteGet$Response(params).pipe(
      map((r: StrictHttpResponse<RetraitVisiteDto>) => r.body as RetraitVisiteDto)
    );
  }

  /**
   * Path part for operation retraitsVisitePost
   */
  static readonly RetraitsVisitePostPath = '/api/retraits-visite';

  /**
   * Crée l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retraitsVisitePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  retraitsVisitePost$Response(params: {

    /**
     * Entité
     */
    body: RetraitVisiteDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, RetraitsVisiteService.RetraitsVisitePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Crée l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retraitsVisitePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  retraitsVisitePost(params: {

    /**
     * Entité
     */
    body: RetraitVisiteDto
  }): Observable<void> {

    return this.retraitsVisitePost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation retraitsVisiteGet2
   */
  static readonly RetraitsVisiteGet2Path = '/api/retraits-visite/{id}';

  /**
   * Renvoie l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retraitsVisiteGet2()` instead.
   *
   * This method doesn't expect any request body.
   */
  retraitsVisiteGet2$Response(params: {

    /**
     * Identifiant de l&#x27;entité
     */
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, RetraitsVisiteService.RetraitsVisiteGet2Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retraitsVisiteGet2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retraitsVisiteGet2(params: {

    /**
     * Identifiant de l&#x27;entité
     */
    id: number;
  }): Observable<void> {

    return this.retraitsVisiteGet2$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation retraitsVisitePut
   */
  static readonly RetraitsVisitePutPath = '/api/retraits-visite/{id}';

  /**
   * Met à jour l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retraitsVisitePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  retraitsVisitePut$Response(params: {

    /**
     * Identifiant de l&#x27;entité à mettre à jour
     */
    id: number;

    /**
     * Entité
     */
    body: RetraitVisiteDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, RetraitsVisiteService.RetraitsVisitePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Met à jour l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retraitsVisitePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  retraitsVisitePut(params: {

    /**
     * Identifiant de l&#x27;entité à mettre à jour
     */
    id: number;

    /**
     * Entité
     */
    body: RetraitVisiteDto
  }): Observable<void> {

    return this.retraitsVisitePut$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation retraitsVisiteDelete
   */
  static readonly RetraitsVisiteDeletePath = '/api/retraits-visite/{id}';

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retraitsVisiteDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  retraitsVisiteDelete$Response(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, RetraitsVisiteService.RetraitsVisiteDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retraitsVisiteDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retraitsVisiteDelete(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<void> {

    return this.retraitsVisiteDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation retraitsVisiteGetList
   */
  static readonly RetraitsVisiteGetListPath = '/api/retraits-visite/list';

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retraitsVisiteGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  retraitsVisiteGetList$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, RetraitsVisiteService.RetraitsVisiteGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retraitsVisiteGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retraitsVisiteGetList(params?: {
  }): Observable<void> {

    return this.retraitsVisiteGetList$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation retraitsVisiteLoadList2
   */
  static readonly RetraitsVisiteLoadList2Path = '/api/retraits-visite/load-list';

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retraitsVisiteLoadList2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  retraitsVisiteLoadList2$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, RetraitsVisiteService.RetraitsVisiteLoadList2Path, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retraitsVisiteLoadList2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  retraitsVisiteLoadList2(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<void> {

    return this.retraitsVisiteLoadList2$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
